// <publish-status-name status="{{story.status.publish}}"></publish-status-name>
const template = '{{$ctrl.name}}';
const PublishStatusNameController = function controller(schemaService) {
  const $ctrl = this;

  $ctrl.$onInit = () => {
    schemaService.getStatuses('publish')
      .then((data) => {
        $ctrl.name = data.find(val => +val.id === +$ctrl.status).name;
      });
  };
};

const controllerArr = [
  'schemaService',
  PublishStatusNameController];

const component = {
  template,
  bindings: {
    status: '<'
  },
  controller: 'PublishStatusNameController'
};

export default function (ngModule) {
  ngModule.component('publishStatusName', component);
  ngModule.controller('PublishStatusNameController', controllerArr);
}
